import styled from 'styled-components';

import { type Breakpoint, sizeDown, sizeUp, vars } from '~/theme';
import StepNumber, { stepNumberVars } from '~atoms/StepNumber';
import NavStep from '~molecules/NavStep';
import { headerVars } from '~organisms/Header';

const bp: Breakpoint = 'lg';

export const Container = styled.div({
  ...vars({
    [stepNumberVars.iconSize]: sizeDown('25rem', [bp, '20rem']),
  }),
});

export const MobileNavStepTrigger = styled(NavStep)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  '.anticon': {
    fontSize: '25rem',
    color: theme.palette.desertSand,

    transition: 'transform 300ms linear',

    '&[data-is-expanded="true"]': {
      transform: 'rotate(-180deg)',
    },
  },

  [`*:has(${StepNumber})`]: {
    marginInlineStart: '15rem',
  },

  [theme.breakpoint.media.min[bp]]: {
    display: 'none',
  },
}));

export const Backdrop = styled.div(({ theme }) => ({
  position: 'fixed',
  insetInline: 0,
  insetBlockStart: headerVars.headerHeight,
  insetBlockEnd: 0,

  backgroundColor: theme.palette.quickSilver + '80',

  '&[data-is-expanded="false"]': {
    display: 'none',
  },

  [theme.breakpoint.media.min[bp]]: {
    display: 'none',
  },
}));

export const Content = styled.nav(({ theme }) => ({
  position: 'absolute',
  insetBlockStart: headerVars.navHeight,
  insetInline: 0,

  backgroundColor: theme.palette.darkLiver,
  paddingInline: sizeDown(headerVars.paddingInline, [bp, '0rem']),
  paddingBlockStart: sizeDown('25rem', [bp, '0rem']),
  paddingBlockEnd: sizeDown('30rem', [bp, '0rem']),

  '&[data-is-expanded="false"]': {
    display: 'none',
  },

  [theme.breakpoint.media.min[bp]]: {
    position: 'static',

    '&[data-is-expanded="false"]': {
      display: 'block',
    },
  },
}));

export const NavigationList = styled.ul(({ theme }) => ({
  listStyle: 'none',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: sizeUp('10rem', [bp, '20rem']),

  height: '100%',
  width: 'inherit',
  padding: 0,
  margin: 0,
  paddingInlineStart: sizeDown('38rem', [bp, '0rem']),

  [theme.breakpoint.media.min[bp]]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

export const Divider = styled.li(({ theme }) => ({
  width: sizeUp('25rem', [bp, 'clamp(20rem, 6vw, 50rem)']),
  height: '1rem',
  marginInlineStart: sizeDown('2.5rem', [bp, '0rem']),
  transform: 'rotate(90deg) translateX(5rem)',
  backgroundColor: theme.header.primaryAccent.text,

  [theme.breakpoint.media.min[bp]]: {
    transform: 'rotate(0deg)',
  },
}));
